var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHierarchyNodes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33333 5C3.33333 4.07953 4.07953 3.33333 5 3.33333H6.66667C7.58714 3.33333 8.33333 4.07953 8.33333 5V6.66667C8.33333 7.58714 7.58714 8.33333 6.66667 8.33333H5C4.07953 8.33333 3.33333 7.58714 3.33333 6.66667V5V5M11.6667 5C11.6667 4.07953 12.4129 3.33333 13.3333 3.33333H15C15.9205 3.33333 16.6667 4.07953 16.6667 5V6.66667C16.6667 7.58714 15.9205 8.33333 15 8.33333H13.3333C12.4129 8.33333 11.6667 7.58714 11.6667 6.66667V5V5M3.33333 13.3333C3.33333 12.4129 4.07953 11.6667 5 11.6667H6.66667C7.58714 11.6667 8.33333 12.4129 8.33333 13.3333V15C8.33333 15.9205 7.58714 16.6667 6.66667 16.6667H5C4.07953 16.6667 3.33333 15.9205 3.33333 15V13.3333V13.3333",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchyNodes);
export default __webpack_public_path__ + "static/media/hierarchy-nodes.51c0c8cd0fb45f369c0929b027bd8071.svg";
export { ForwardRef as ReactComponent };